import React  from 'react';
import Grid from '@material-ui/core/Grid';
import NoMatch from 'components/noMatch';
import Login from 'components/login';
import {
    ModalPattern,
} from '@worthy-npm/clarity';

import I18n from 'lib/i18n/i18n';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getItem } from 'actions/item';
import {
    isMobile,
    LD_SK_EXP_VERSION
} from 'helpers/ApplicationHelper';
import WorthyApiErrors from 'lib/api/worthyApiErrors';
import ShipmentInformation from './../listing/shipmentInformation';
import ScheduleShipmentModalPopup from "../popups/scheduleShipmentModalPopup";

import ScheduleShipment from "../scheduleShipment/scheduleShipment";
import { chatBotSaveLog } from 'actions/item';
const SHIPMENT_DOM_ID = 'shipment-information';
import Experiments from 'lib/experiments';
import Listing from './../listing/listing';
import LightListing from "../lightListing/lightListing";

class ScheduleSecureShipment extends React.Component {
    constructor(props) {
        super(props);
        const itemId = props.item.id;

        this.state = {
            requestingNewItem: false
        };
        this.isMobile = isMobile();
        this.props.getItem(itemId);
    }

    static getDerivedStateFromProps(props, state) {
        const {
            Item,
            ADO,
            ChatBot
        } = props;

        const expsFromStore = props.experiments;

        if (Item && ADO && ChatBot && typeof ScheduleSecureShipment.version === 'undefined' && expsFromStore) {
            let user = ADO.user;

            try {
                // Kindly borrowed from itemChatBot.js
                // Refactor once `jb_cui` exp is finished
                const chatBotType = user && user.last_name === "" && !Item.high_value_estimation ? "missingDetails" : (Item.item_type === 'watch' ? 'watch' :
                    ((Item.high_value_estimation || Item.auto_reestimate) ? 'highValue' : 'standard'));
                const exps = new Experiments(expsFromStore);
                ScheduleSecureShipment.version = ChatBot['conversationFlow'][chatBotType][exps.chatBotExperimentTest(ChatBot['conversationFlow'][chatBotType], ADO, Item)]['version'];
            } catch (e) {
                console.error('Smth went wrong during fetching CUI version', e);
            }
        }
        return state;
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }

    componentDidMount() {
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // This callback reduces rerender cycles but limits the component children to be re-rendered via properties
        // so add any additional condition in order to control render process
        return nextProps.Item && nextProps.Session;
    }

    logAction = (message, params) => {
        const MAX_KEY_LENGTH = 20;

        chatBotSaveLog(this.props.item.id, {
            key: message.toLowerCase().replace(/\s/g, '_').substr(0, MAX_KEY_LENGTH),
            direction: '1',
            type: 'sssf',
            text: message
        }, ScheduleSecureShipment.version);
    };

    openSSFonMobileHere = (itemId, step) => {
        this.logAction('Set up shipment modal presented', itemId, ScheduleSecureShipment.version);
        this.setState({ openSchedulePickupForm: true, step: step });
    };

    closeSchedulePickupForm = (step) => {
        this.setState({ openSchedulePickupForm: false, step: step });
        if (this.stopAnimation) { this.stopAnimation() }
    };

    renderShipmentInformation (Item) {
        return (
            <div style={{width: "100%"}} className='text-center'>
                <ShipmentInformation
                    openSchedulePickupFormForMobile={this.openSSFonMobileHere}
                    id={SHIPMENT_DOM_ID}
                    item={Item}
                    logger={this.logAction}
                    version={ScheduleSecureShipment.version}
                    editable={ this.props.editable }
                    fromCui={false}/>
            </div>
        )
    }

    shipmentScheduledSuccessfully = (data) => {
        const {
            Experiments,
            Item,
            P13N
        } = this.props;

        if (this.isMobile) {
            this.setState({ openSchedulePickupForm: false });
        } else {
            if (Listing.getVersion({ item: Item, P13N, experiments: Experiments }) === LD_SK_EXP_VERSION) {
                this.setState({ step: this.messageStepIndex })
            } else ScheduleShipmentModalPopup.hide();
        }
    }

    renderIt(Item) {
        const {
            openSchedulePickupForm,
            step
        } = this.state;
        const { isSKExperiment } = this.props;

        return (
            <div>
                {
                    openSchedulePickupForm ? <ModalPattern
                        key={'ModalPattern'}
                        textAlign={'center'}
                        title={ I18n.getString(`listingPage::${ step === 1 ? 'setUpShipmentTitle' : 'scheduleShipmentTitle' }`) }
                        closeIcon={ true }
                        closeOnClickOutside={ false }
                        closeOnEscape={ false }
                        isWide={ true }
                        onClose={ () => {
                            this.setState({ openSchedulePickupForm: false });
                        }}>
                        <ScheduleShipment
                            version={ScheduleSecureShipment.version}
                            onClose={(step) => { this.closeSchedulePickupForm(step) } }
                            logger={this.logAction}
                            isSKExperiment={isSKExperiment}
                            onShipmentScheduled={ data => { this.shipmentScheduledSuccessfully(data) } }
                            step={step}/>
                    </ModalPattern>: null
                }
                <Grid container className='schedule-or-edit-shipment-by-yourself' spacing={0}>
                    { this.renderShipmentInformation(Item) }
                </Grid>
            </div>
        )
    }

    render() {
        const {
            Session,
            Item,
            getItem
        } = this.props;

        const {
            requestingNewItem
        } = this.state;

        const LOGGED_IN = Session && Session.isLoggedIn;

        if (Item instanceof WorthyApiErrors && Item.hasError(404)) {
            if (LOGGED_IN) {
                return requestingNewItem ? <p>Loading...</p> : <NoMatch />;
            } else return <Login
                showLinkToRegister={ true }
                onSubmitForm={ () => {
                    this.setState({ requestingNewItem: true });
                } }
                onLoginSuccessful={ () => {
                    getItem(Item.id, false, this.props.location.query).then(() => {
                        this.setState({ requestingNewItem: true });
                    });
                } }/>
        }

        if (Item) {
            return this.renderIt(Item)
        } else return <p>Loading...</p>;
    }
}

const mapStateToProps = ({ Item, Session, ADO, ChatBot, Experiments, Personalized }) => {
    return {
        Item,
        Session,
        ADO,
        ChatBot,
        experiments: Experiments,
        P13N: Personalized
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getItem }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleSecureShipment);
